//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as echarts from "echarts";
import EsQuery from "@/javascript/esQuery";
import goBack from "@/components/public-components/goBack/index.vue";

export default {
    components: {
        goBack,
    },
    data() {
        return {
            minHeight: 0,
            text: "",
            pointData: [],
            linksData: [],
            isShowContentScroll: true,
            animation: false,
            description: "",
            title: "",
            show: true,
            picList: [
                // require("../../../assets/nz-yjzf-img/phone.png"),
                // require("../../../assets/nz-yjzf-img/phone.png"),
                // require("../../../assets/nz-yjzf-img/phone.png"),
                // require("../../../assets/nz-yjzf-img/phone.png"),
                // require("../../../assets/nz-yjzf-img/phone.png"),
                // require("../../../assets/nz-yjzf-img/phone.png"),
            ],
            noImg:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOwAAAEmCAYAAABh13xyAAAgAElEQVR4Xu19Z3MbSZbtISV6A4IACHrvRVISpe5W25nd7d7d+bq/ZuP9gI39M7tfZ96beS+23bSjDI3oSdDBEQS9ty9uUsWmJIosAFVAoercCIa6pcxbmSfzMN01Obgmy6tbHfdy7/8ncPE1gPLr/8b/JgJEICMIbAM5fzs7P/33hirXTI7WhGBsuysnJ/dnABUZaRY/SgSIwG0IbF5cnD+7Imxobe+/gIt/y8+7B1dxHnJzr/6JMBIBIpAhBM7PL7C1f4LjkzMAOf99jbC7W7IN9rkKSdYMDQ4/SwRuQkBIG9s6FMLuXifshRT2u4uIGhEgAhZDILpxoFpEwlpsYNgcInATAiQs5wURyCIESNgsGiw2lQiQsJwDRCCLECBhs2iw2FQikBJh5Zr58OQUp2fnuFB3yxQiQAQSQSAnB7h/LxeFefd1PaMmTVgh6+7hMYmayOiwLBH4AAJC3NLC/DtJmzRh949OcHJ6zgEgAkTAIATy7ueiuCDvVm1JE3Z7/4irq0EDRTVEQBCQVba8uMAcwm7tHRFlIkAEDEbAVULCGgwp1REB8xAgYc3DlpqJgOEIkLCGQ0qFRMA8BEhY87ClZiJgOAIkrOGQUiERMA8BEtY8bKmZCBiOAAlrOKRUSATMQ4CENQ9baiYChiNAwhoOKRUSAfMQIGHNw5aaiYDhCJCwhkNKhUTAPARIWPOwpWYiYDgCJKzhkFIhETAPARLWPGypmQgYjgAJazikVEgEzEOAhDUPW2omAoYjQMIaDikVEgHzECBhzcOWmomA4QiQsIZDSoVEwDwESFjzsKVmImA4AiSs4ZBSIREwDwES1jxsqZkIGI4ACWs4pFRIBMxDgIQ1D1tqJgKGI0DCGg4pFRIB8xAgYc3DlpqJgOEIkLCGQ0qFRMA8BEhY87ClZiJgOAIkrOGQUiERMA8BEtY8bKmZCBiOAAlrOKRUSATMQ4CENQ9baiYChiNAwhoOKRUSAfMQIGHNw5aaiYDhCJCwhkNKhUTAPARIWPOwpWYiYDgCJKzhkFIhETAPARLWPGypmQgYjgAJazikVEgEzEOAhDUP27RpPjk9xd7eIQ4Oj3BwdIyjo2PI352cnuHs9AznFxfvteXevVzcv3cP8md+Xh7y8u6jsCAfRYXyU6B+KNZDgIS13pjc2aLT0zNsbu+qn53dfRwdn9xZJ9EC93JzUVJciLLSYpSXlag/c3NyElXD8gYjQMIaDKiZ6ja2drC6tqmIenFt1czPuw9XWQlKiwsVyWSVLMjPg/x93v17yM3Nfa9Zsvqenp1ByH94dIKj42PsHxxj7+AQO3sH2Ns/fKuO6KgoL4HbVYaK8lK1IlPSjwAJm37ME/5iLL6JYGQNh0fHV3WrPBWo8pTD6y43ZfsqZN7e2cf61i7Wt3YQ39h5q92lJUXwuF3wVbpw//69hPvECskhQMImh1taau3tH2BuMYz9g8vVrtJVCp/HhYYaL/Lup3eFOz45xWp8E7H1bURiG1f9l22y1+NCrd+rzsAUcxEgYc3FN2ntK+EYgpEYZOfrLi9FXbVHEdUKIldY0dgGgtF1RWIROd56KytQV03imjlGJKyZ6Cah+/z8HLMLQaxvXm5BhaR9nU1JaEpPFTnrzi1HEIzEr4jr87jRUOPjOdeEISBhTQA1WZXy/DI5u4TtnT11aTTQ3azOqNkg+wdHmF0KXxE3NzcHNVUe1Pg96vmIYgwCJKwxOBqiZSawgvjGtrrpfdrfjuIsfAvd3T/EzELo6pwrF1J1fi/8vkoIiSmpIUDCpoafYbUjq+tYWImop5hnj7tRUpTdhgtyuxxYjmA1vqUwys/PU9tkn6fCMMycqIiEtcCoi+HD8Pgszs8v8Li3FdU+twVaZUwTomubWAzF1M5BpLioAE11frjKS435gMO0kLAWGHBtK1zn96hzqx1lJbKGlUgcG1u7qntifNFY51cEpuhHgITVj5UpJQ8Oj9XqKvIPzwZQWJBnynesonR2MayIK3bP8hRU5XGjnjfKuoeHhNUNlTkFl4JRhKJx1Fd70d9l3ecbI3t/dnaOibllLIfXlFpxQBDDC7lV5sXU7UiTsEbOxCR0vRidwfHJCT593K1sdZ0ku3sHmFkMX90oy1NWQ10VvG6Xk2BIqK8kbEJwGVdYvGyiaxtYW9+C21WKZ4+6jFOeZZpi61tYWFnF2puLKfEMam+uU2/RlLcRIGHTPCPEKGIptApZXbTtoKyuZSVFaW6J9T63FIpBfsRbSLbJrY218GSJ4Ui60CRh04S0uLMtLIevnjfKS4vhrSxHY43XFG+bNHXL8M/I+XZsehGh1XWlu9bvQUOtX11QUQASNg2zQLa/04EVnJycKi+bxjofOptr0/Dl7P3EYnAV47PLqgPig9vRUnejX2/29jC5lpOwyeGmu9baxhbmFkLK4dzvrUBve6Ptn250g3NHwc3tPbx4PaciakjUi+62BseTloQ1anbdoEculMTzRsTqXjcmwpCS6v3DIwyNzqoIGBWuUnS1Njp6e0zCpjSdPlxZwriI580lWX3o62w06Uv2Vyuk/fXVtAowJ2dasZByqpCwJoy8hHIZnZyHXKCQrMYAvLG9i59fTillPe1NcDnszVpDkYQ1Zj5daZEIEa+nA+rZpraqEg97Wgz+gnPViVmjuO7J++zD3jZHnmdJWIPnfzgax2IwCnm2efa4CxIulGIcAr+NzCgDi8baKtRWWyNkjnG9u1sTCXs3RrpLyLPNq/FZtRUefNCmboUpxiIQi29haGxWRWoc7Otw3CpLwho4n8QBXRzRxZ9V/Fop5iDw2+gM1ta30dpYgyqvfXyH9aBFwupBSUcZWV1fvp5RTuifDfbAVVasoxaLJINAMBrHyOSCykbwoNOe/sMfwoWETWbG3FBHwpLKD1dXgwC9Q83//Dyqnnke93U4ykmAhDVofr0YnYYE2/54oIMG6wZhepua4YmAsjcWB4EqB90VkLAGTC6xFX49veB4NzkDoNStQtsWeytdyhXPKULCGjDSC8sRRGLraGusRmeLcyaPAdAlrUJC6/zPL6MqVeZgf0fSerKtIglrwIg9H51WnjifP+lR76+U9CDwtx9fqRy4Twe6HJOQi4RNcW5JxPuRiTlINrcvn/amqI3VE0Hg51dTKgpjb2ezY35RkrCJzJAbykpSqMByGI21PjzooIF/inAmVP31zJKKUNHSUAO/jWI53wYCCZvQFHm/sBZTWGyGxXaYkj4E5pcjmJoPOsqDh4RNcX69HJtRDtZ//KRfZT6npA+B8Oo6Xk0E1DNaR0t9+j6cwS+RsCmALzbDvw1Pquxs33zxKAVNrJoMAnJ+lXOskyyeSNhkZsqbOrv7BxibDCgzRDFHpKQXAbnw+/bXMZX5/dGD9vR+PENfI2FTAD4W38TcYgh2zomTAjymV5UnHXnakR3O04fOiOtMwqYwrZaCqwhF19DVUofWxuoUNJlT9buhSeTdv4fWhir4PfaMpv/nb58r8J4NOuNJjYRNgSsSYE0CrUnGOVllrSSSn/WXkTnVpE8G2lDpMi69o1gZbe8dWOKXwJXxxMMuR2R6J2FTYNnE7CK2tvfw0UAHvBaLUP/Tqxls7uyjoqwYnz6623Tv9PQMK9HL4N2a7B8eQ86JIqJLRLahmgz2NmectGKeKL9AnOK1Q8KmQNjh8TmVNvHLjx6gtLgwBU2pVQ1G1zExH3pLiUYs2RLfJpLpXQg9PhfEYugym9xdoulsqvWioymzR4EfhsZVao+BnjZH5JolYe+anbf8+9DIFGRl+qfPHiI/734KmlKrKoQdmb6Mkp+oCGG/etp9RVgho6zKXnfZlSrt/Cv/JqFZrCQ/Pp/A9u4++ntaUVKUuV+a6cKEhE0B6Z9fjKvaf/rDkxS0GFs1Gt/Ci/EFpTSRs6u2wvrcZXjalz3hbZxmT0zCJsmX8/Nz/PpqUkVF/OcvHyepxfhqcjO8d3CEWl8FHnZfJogenlxEbGMHt21hs5WwvwxPY31zB70dTSqdh92FhE1yhGUrLFti2SZ+/bk1rJxmFiOYXYqqHv3xo54rU8mhsfkrwva23eyvm62EfT42h9X4JrraGlTSLLsLCZvkCIv9sNgRi/2w2BFnWpRD928TqhlyBq3x/R5idSkcV6uubHevn02lbHlpkXry0QgrZ9rGGv1PVPX+yoyeayVZVnRtE52tDaisIGGjG5d5h6+yc4bWdi/kL/zu2xMQb+1dPgfYVeR2WG6J5XZYbokzLdffXRNpi2yTZdXVVuFE6iZ6Tk5Ut57yJOzbKJGwH5g1eweHGJ2YV47TEmki03LTO6rWJj0rrHb2vWkVXtvYUVvqm1ZfrrDpHXluiZPE22qEva0bes6wf/tpTBlF3GQMYeXzLVdYrrC6KJyNhJWbY7Erjm/uqj4KQT0VpepP7Snom0/73juTkrC6pkRaCnGFTRJm7QxbUlyIrzJ8hpXb4XetlK6bEN7WxYHOBoRjm2rL+yEzRhI2yUliQjUSNklQrXRLrNfSSbNi0ros/y+3xpqVlJC3zv9+mBsSNslJYkI1EjZJUK1EWHnSEQun6y5018PVfOgMK/V+fDmttsSaieJNcJCwSU4SE6qRsEmCenJ6iucj08qGWGyJrSy3XTppXj23mTGSsNYZXRI2ybE4Oz/Hb2KaeC8X//yFdUwTte7I6nn130fHahWVLXBRwfuB4t5dnW+DxGqB5nhLzFti3RS2ovG/1vhkDSFu67wVHQNIWBJWN2ElYqJETvzm80cZNc+7qcEaYe/yh9XTWe3G2YqEpfE/CatnDqsyWk6df/x0wHI5SvUYS+jtqKaLhNWLmHnleIZNAVurRJy4bYXVbIVT6OaVnbElCftqCmJH7ZT8OiRsCjNZcsJKbthPHnUZGuQshSZdVdVWRbFu6myuSUnlq8lFFdPJioRlxAluiXVP7un5FaxvbuNxbyuqLZaMySmXTiQsCaubsIGlMKJrGyprnWSvs5I45dLp+6Fx7DII29XUo3vdLSxcDscQDMfQ0VyL9qbUtp1Gk90pl04Mc8oVVjd3IrF1LCxH0FTrQ6/FcsOSsLqHMasK8tIpweGSBM5Hx8cqxeTe/iEOj47xqLcVNRY9w9r90ml4MoBQdB2u8hIUFxagoCAfhfn5KC0pstzbeIJT7cbiJGwCKO7tH2B0MvBWDclN+vHA3ZH1E/iMIUWdcukkhis/PB+/ylCggVdX7UVDbZUhWFpJCQmbwGishGOQn+b6KlSUl6oAZlYNXu2USycZPrHrllyxcvkk6UUWg6tqhe3raklgdLOjKAmbwDiNTQXUpLBiLp13u+GUM+y7/b64uMBfvnuBnBzg6UC3cs6wk5CwOkdTi0Msxf/1q0HkyIywsGjeOkak17ju+WM1b52bhmBodBax9S1bxiomYXWSbm1jC7OBIPzeCgw+aNNZi8UygcD8cgRT80HUVHnQVO/PRBNM+yYJqxNaLResFY0kdHbBMcW2dvbw9xeTKC4qxEBP9uQJ0jNAJKwelMQzZ2RKOYH/8ZM+FBUW6KzFYplAQCLd/+VNZvYnA13Kcd8uQsLqGEntOcdVVozPBjMfNFxHkx1fRHNs72iphzy92UVIWB0jef05p6etQUcNFsk0AvK0Mz67DL/XjZZGa5mNpoINCasDPc2NLhuec3R0xxFF5PlNHAPk+PKw1z6XhCTsHdNX3vUkD6z8mQ3POY5go45Oau+xUvTjRz3IzbX2M5yOLqkiJOwdSFktS53egWU5qJtiuTEWiyexfLKDkLB3jOLW9i4mZpfgdZcrCydK9iAwMrmAYDSOtqZa+Dy/58vNnh6831IS9o7Ri29sYyaworxxxCuHkj0ITAdCmFsKKycAcQawg5Cwd4xiLL6JucUQ6vweDHQ322HMHdOHwEoUk3MrtrJ4ImHvmL6ra5uYXwqhvtqL/q4mx0x2O3R0MRTD+MwS/D43Whrs8bRDwt4xM8Or61hciaC5rgo97dZ/gzXDD/ZdiG5LnGUlogcjcYxMLajzq5xj7SAkLAmb8DwmYROGzLAKJKzNCCuJra67w93WvYn5kPpnIWBjjUf3pBLb3JvyyOpWkKaCXGEBhNZ2xbYafvft71pbe0dpGhZzP7Ma38T8opxhPejvstel05+/H1bgSdynh932O58vBFcxMbuM6qpKNNdXmztR0qSdK+wdQK9v7mB6XmxS7eUHKw75f/1pTPXeiHQeaZqvCX1mZiGE2cUw6mt86scOQsLeMYpikyqhYSrKS/Dp4247jLnqg+Sj+WVkTv13T2stmuvsMaGvD9DY9CKWw2tobaxBlddti7EjYe8YxpOTU5WlriA/D5Klzi4iZ90X4wuqOwOdDVlxJk0U+19HZiCGLz3tTSoMqh2EhNUxikPDUzg9O8PXnz+yjTP0QjAG7dLpk4E2yyXz0jEsdxb5fz+NqPjRg/2dyM+7f2f5bChAwuoYpfGZRWzv7OHjh53wVJTpqGH9IuNzQSyG1lRD//TlQ+s3OMEWHp+c4v/+fVgFE3860JVgbesWJ2F1jI3mwN7aUI2u1jodNdJfRFbMRGQpHMfewZHaMbQ3Jh+orN5fackI+6HVdQxPBFBZUY7O1vpEoLF0WRJWx/BIDlhxYneXl+LZY2v+ttaeaHR0x9AiVt1OvxyfRyS2oaJNSNQJuwgJq3MkX4xOQ7ZZzx51we0q1VkrfcVI2N+xlkwA/+f7l+ovnvR3Is8m51fpDwmrk1NLwVWEomuoqarEo57sTgExsxjB7FJU9Xywtxl+j0snCtlRbH4pgqlAEK7yUvS0N2ZHo3W2koTVCdTxyQlejs2qUDFffvQApcWFOmtar9h3Q5NX59evP+2zXgNTbNHPr6ZUrp3utkZUWHA3lEr3SNgE0JtfCmN1bQPVPjceZ6kz+3WDCZ+7DE/7Lp3y/3bN6qmjKXvN+MSySSyciosKMNBjn+Br2jQlYRMgrBhRvBqfhaQ4FN9Y8ZHNNrnufnfdYEI7A2ezmaLk6v1haFwFfLeTscT1OUbCJsg4LQKFvO9JUHHxdMkW2dk7wA8vplVz5Tnn+nbYDoR9PjaL1fgWvG4X2lus+fyW6lwhYZNAUMuzU1ZShKf97SgsyE9CS/qrXF9d37UfznbCagHX8vPzVD6d+/fsk56DK2yKXDm/uMDEzCLkfVZIO9jXhmKL59sJRtcxMr2sen6TA3oihBVPn+29A8uYM0pUCfF9vZebi96uZssm2U5x2qnqXGGTRFHOsZNzS4q0YqcqWe3kMsqKIg7tP76cVmc7kZuechIhrHZxpVlJZcrT5/z8HKNTixCrJgkULrfC5WX2MPL/0DwiYVNgmEyY2YUQ1je3lRaJrCjEtVrWb+0ZR9r4oUulRAh73dMnU6558mwjb63yp+Dd1dpge7JyhU2BrNerRlbXsRSK4vz8Qm2Na/yV6Gy2RtCv62S9LRZTIoS9vr1Ot2veyempStYsfq4i8nzT2dqQNfcIqU45rrCpIvimvjwpLCxHsLm9q/7GV1mOp/2ZyxQg2+DfxuaVgYSIbF8/f9yJosKbL8gSIex1S6l02hLLLffQ6AwOj06QkwPUVHlVJAm75M3RMxVJWD0oJVBG3PAk8Lj4YYqjgDgMpFvkjCnO6dqZ9S6ySvs0wl43pvhQu4cnFxGKbap/Tqdr3k8vJ7G5vQe3q0xF85fV1WlCwpow4kvBKELRuHLFE5e8dMp1P1c9K6vWtutb59u2uXfdNpvV162dffz9xQRKigvR3+3clCkkrAkzbGNrB1Nzy6jyuPCkr92EL7yvUi6CRqeXr1ZVKVFRVoxPH+nbll/f5uptsPjRpsuMUUvQXO2rRHOafwnqxSMd5UhYE1CWi5HnI9PqueefPjM/msN1CyatO8nc3r67Ot8GTbpNGF+NzyMc20BHSz087nITRi07VJKwJo3T8PgcJLfs5096UF5abNJXflerxWiSVfVRd9MHL5f0NOSuQOQfurjSozvZMnaMz5QMFiRsMqjpqCM3xpHYOrrb6tFSn3wIFh2fuioil02VNnMnk85t7+7jx+cTKCoswMNe+3ngJDLGJGwiaCVQVgtAns5zbALNy6qigeUoJudX4PTzqwwaCWvS1JWwqBIeVeRfvxpEjjwcUpJCYGhsFrH4FrraGtSTjpOFhDVx9EcnA9jbP7BsHCgTu26Yaonw8ZfvXihDiacD3ZYz+zSsozoVkbA6gUqmmBYHqr2pBh0WMVVMph+ZrBPf3MGvw9PKK+pBV3bH0jICRxLWCBQ/oEOsniQIeWVFGT552Gnil+yremJuBQsrUVsltEpltEjYVNC7o65s54ZGplRImX94NoDCgjwTv2ZP1WLdJFZOfd0tKC2+PcWpPRF4u1ckrMmjPBNYUQmZxO2usdZ+GeLMhG93/xDf//ZaGaBIfhwKb4lNnwNr61uQkDJVngo86XP2G2KiYGvxhSVVpKSMpJCwps8BCaci22IRPu8kBreWLtKO8YUTQ+L30twSJ4tcAvXGpxeUtY7EMrZqGJkEupOWolr2udzcXJV9zkk+r7cBTMKmYfqFV9exuBJBjc+NR1kagDwNML31Cc07x27Z51LFkYRNFUEd9WW1kGRaIv/y1SByafV0J2q/jcxgbWPb8d457wJFwt45dYwpoCWFHuhuVsHaKB9GYP/wCN/+Mqasmp70czt8HSkSNk3MkZw8kpuHt8V3Az63FMZ0IARfpQttzfaM4H83CjeXIGGTRS7BenJb/Hx0WmW/+/rzRyooGuVmBH4ZnoZ4O3W3N6IiAzGxrDwuJGwaR0fCxkj4mO7WerQ0pMdHNo3dM+RTWzt7+PuLSfULbbC/Sxn9U35HgIRN42zQYj3RtvjDoGtpN2qqPGhKk+N/GqdAyp8iYVOGUL+Ciwvg5dgMJDn0RwMd8Do4NtFNqEkg9u+HXmP/4AiPHmRPkjH9MyD1kiRs6hgmpCEYjmE5HOOb7A2oLaysYmJuGa6yEvR0NCWEq1MKk7BpHml5k5VVVi6f/vHTARTk04NHGwLtsqmztR5iMEF5HwESNgOzYnp+RSXQkosnuYCiALH1bZWGI088c/o6GFLnA5OChM0AW3b3DjA2FUBpSRG+eNoLXoQCWvZ0ScFRV+3NwKhkxydJ2AyNk+YQwPAxUCkjf341BTH0H+zvsG32dCOmGglrBIpJ6NDCx5QWF16usg5+cHzxeg7RtU3U+r1orKtKAk3nVCFhMzjW2iorkSgkIoUTRSya5LJJra59HbhPC7BbpwEJm0GWSAhUCYUq8oeP+xyZPlEumuTCSc6tcn6l3I4ACZvhGSK5ZGPxTfi9FRh84KwQMvIePTa9pG6GxVDiXm5uhkfD+p8nYTM8RpJ0eXh8FuIc0NvegCaHnOGk35IvRxKGtTfXwVvpyvBIZMfnSVgLjJNEVZToiuL/KRdQxYX2zyyupY8UbxzxyqHoQ4CE1YeT6aXmFoKIrW/BCQ7uYiv87a9j6oJpoKcV+Xm09tI7wUhYvUiZXC4YWcNyaBWtjdXoarG303YwEod45fg8FWhrqjUZWXupJ2EtMJ5iVzwxs6giKz7tb1eRFuwsksf2l1dTKCstxoPOZjt31fC+kbCGQ5qYQknjIefXze1dR5kq/jA0jp29A/i9bjTVVzOMqc5pQ8LqBMqMYkLWidlFiG2xXDTJ6lpSXGjGpyynU8j649A4LgD1i6qnvcnxqST1DBIJqwclE8pcJ6urrBiPe9tQVJhvwpesq1J+UQ1PXgZZJ2n1jRMJqw8nQ0vJG+TU3JJaWYWsYjBRWOAssmqAHh4dQ2yJJUNdcVGheuKR5FeUmxEgYdM8M46OT9QFk0zU8tJiDPa1ocihZL1O2lfjAWxs7yI/Pw897Y0ocsBbdDJTj4RNBrUk68i5bXp+GScnp/C4y/Gwu5kRJ95gKbuOkckAVuNb6izb0VLPEKc3zDMSNknyJVpNAokHliMqNIzYDT/sbuElyw0gDk8EEFpdV/9CZ/b3ASJhE2VeguUlEuDCShira5uXk7DGi75OBhi7DUZxCBDHABEJCdvaVEun9jeAkbAJEjCR4vsHh5gJBJWBuzio93c1Ma+OTgDFTHN0ahFy5pdAdeIgIIYWThcS1qQZEImtY2klivOLC7VK9HU0OuaN1ShID49OMDaziFh8S6msq/Ghvtrr6OgcJKxRs+uNHrn9FR/Xnd199TcywWRlpSSPwPUtsjz9tDXXoqTIGQYm76JGwiY/j96qKZdJkrh5JbSqVtWykiK0NdWogOGU1BGIb+5gJhBSTz8S/kriP8mK67RcuyRs6nMJksBpYTmizqqXq6oHDzqaaB9rALbvqhibXsRyeE39dUFBPlrqq1HhKjXhS9ZUScKmMC5yIbK4ElVBwUUqXaVoaahGlcfe3jYpQGZIVfH2mV0MIb6xo/QJYZvrqx1hLUbCJjGFJJzLSiQGeVuVZxu5xZTnmo5m+nYmAWfSVeaXIlgKxXBwdKwuovw+N+qrfbaOvEjCJjBdTs/OEI7G1Vn1/Pxc1azze9DdVk/71wRwNLKo/PIcn11GMBpXasVKSlJV1vg9tgzqRsLqmD0np6eIrK5DnmrEy0ZErJXaGmuU8T4l8wiI88DcUlgFJBeR8DO1VR5U+dy2MrogYW+Za/JEE16NqzCksvUVkfNpS71fva1SrIfA2sY2FlaiKtaxtuJW+yrVqmuHIOUk7A1zbnNrF9G1DUjGdE1kRW0WojroRtJ6dNTfIjG2WArHlDOBSG5uDjxuF6q8FSgryd5dEQn7Zg6IB41cIq3GN5U5nCZyRpW0kPKuSsk+BORGWVZcbassPSguKkCV161iId+/dy+rOuV4wooTuZxP45vbypNGRFZRGUzJeZPHXC9ZNaE/1FgJrSrvt+tbO9jc3rtadb2VFaipqswa/1tHElaIKUmYIqtxFQhMk2qfWz3PeN3M/m0Lln6gE+HYBkLR+NV2WdJvwAIAAAfpSURBVIq5ykpQXVUJt8vadxOOIqxcHMXil4OlbXsl6oOnogzN9VWOeHi3MxET7dvu/iEWVlbVL++9g0NVXUL1iNmjz+OypJOBIwgrTzHR2Lp6P5UnGrXtrShDtbfCMblsEp3MTiqvfJaDUeUVJGdeEYkrJTfL8ixkpSRdtiasEFWeZeRHez+V7a7Y+sq5hUIE3kVADDAkM4E4G4jIpZTMlWqLGGLYkrBihSQXSaHVuMoKJyJbnKYan/qTQgTuQkBulSXqhfaeqwwx/B5U+zwZdeqwFWHlMkneTyVPjTzTaERtqfPD47b2ZcJdE4j/nhkE3jXEkFy2dX6vslsW++V0i20IK0YO4jkj1kkisvVtrqviipruGWXT74kBxmJwFUJg7XKqqd6f9lvlrCesxE0SoopPqojc+DbU+ug4blPiZLpbkdiG8hDSzrjlZSVoqvOnLfxP1hJWLpGWw6vqrCoiIUPqazxobajO9Jjy+w5AILAcxUpkDfI0JCJb5MZav+mha7OSsOIwLhEejt+cUxtqfOhtb8joZYAD5ii7+A4Ccmcirn2y4orI+Va2yV63eRebWUVYIej8UghinK8ulCpd6GypVSkvKEQgUwiItdxUIHgV3VGspiSWsgQ2MFqyhrBr61sILIfVe6pkeRPPGblUohABqyAgK604GuwdHKmtcVNdtfIOMlIsT1jJuRJYCl/FTZIohA86m2iUb+QsoC7DEJAFRWIph6KXdysSb6qtsVZtl40QSxN2e2cPMwtB9aYq24uO5hrIeZVCBKyOgFhMzSyEcHB4rBznJXNBRXnq0R0tS1gxflgOrV7ewHkr8KCj0ZQzgdUHnu3LXgTkzuX1zBLkKUikrtqL+poqFVc5WbEcYcWUcHYxeHWxJCtqX2djsv1jPSKQcQSEtNpNsrzbdrTUIe9+cltkSxFWrJQmZ5eUtZJcLMmqKjfBFCKQ7QiIC9/YzBL29g/VTlEyzSeTtNoyhJVcNFPzy8pYX+x+JX+qGdfi2T7wbH/2IiBb5JHJBUhmPrlF7mptgKy4iYglCBvf2MbcQlDlpJGoDwPdzZbyQUwEUJYlArchIMYWQlpJWi3OA62NNfB59D/9ZJywEkJUsr2JMNMbJ7tTELieI6iloUaZNuqRjBJWohTOL4VVO3m5pGe4WMZOCEhQOCGuiF7SZoywYrk0uxBUjZX8qbK6UoiA0xCQrfHwREB1u7Wx9k7LqIwQdnN7F1NzyyqsKFdWp01R9vddBMTIQs61Il1tDbf62KadsJJDdWwqoGyCJaRoXyezk3MKEwEty3xubi4edDZ/0L82rYSV7G+jkwEcHR2j1l+pnm4oRIAIXCIgq6ystvKc2d/demMuoLQSdnp+WcWA9VaW42l/B1Kw0OIYEwFbIjA0Nqvc9MRpoLvtfQu/tBFWctbML4bUb4/PBntQWGC8r6AtR5CdchQCEuD+pxeTKkl1S0M1/L63w/GmhbBi4TE8PqvOrf1dzSouMIUIEIGbEZCA968mApDz7MPetrcs/tJC2JnACsSaSXxZH/W2cpyIABG4AwF56pEnn8qKcnS21l+VNp2wkh1OboXFO+GLp73cCnOqEgEdCMjW+IehcRW3rK+rBaVv0p2aTljxvpF3V8la3t32+28KHW1mESLgaAQm51cg0RnFQaC34/L501TCSk7OkYk5FBcWqNVVPBQoRIAI6ENAnGFklRWXvIGeVhQXFZpL2MByRGWNk8TI4ttKIQJEIDEENOd3v9eNlsYa8wi7uXuI56PTyr/1iye9KCstSqylLE0EiIBKOC6rrMSFetLfiYrSwltRiW5cJii/snEIre1eyF/43bcTcDm6gfHpBbhdpXj2qIvQEwEikCQCP7+awsbWLno7m9Hgv90NL2nCvp5dwUo4hrbGanS21CXZVFYjAkRgOhDE3FIE9TU+PGi//eI2acL+MjKjAqk97WtnBjnOOSKQAgJiqigmi2Ku+MlAhzlb4m9/fa2CqX318QOVqIpCBIhAcgjsHRziu19fo7AgH3/4+IE5hP3rD69UjKZ/+fKxMrGiEAEikBwC5+fn+N/fv0RuTg6++eKROYSVD4j86Q9PkmslaxEBInCFwJ+/fa7+WxbA2yTpMywJy9lGBIxDgIQ1DktqIgKmI0DCmg4xP0AEjEOAhDUOS2oiAqYjQMKaDjE/QASMQ4CENQ5LaiICpiNAwpoOMT9ABIxDgIQ1DktqIgKmI0DCmg4xP0AEjEOAhDUOS2oiAqYjQMKaDjE/QASMQ4CENQ5LaiICpiNAwpoOMT9ABIxDgIQ1DktqIgKmI0DCmg4xP0AEjEOAhDUOS2oiAqYjQMKaDjE/QASMQ4CENQ5LaiICpiNAwpoOMT9ABIxDgIQ1DktqIgKmI0DCmg4xP0AEjEOAhDUOS2oiAqYjYDphTe8BP0AEiMB7CCQd5pRYEgEikH4ESNj0Y84vEoGkESBhk4aOFYlA+hEgYdOPOb9IBJJGgIRNGjpWJALpR+Amwm4BKPe5CpGbe5WYPf0t4xeJABF4C4Hz8wvEtg4B5OxeMTO0tvdfwMW/FeTdQ3lxHknLSUMELIDA2fkFdvZPcHRyJoT972uE3e4Gcn8CUGGBdrIJRIAIvI3AJnD+6Vt732Bsuysn595/ABffACgjYkSACGQcgR0g568XF2f/q85XPsXDasbHgw0gAvoRIGH1Y8WSRCDjCPx/4iK3WzM0cgcAAAAASUVORK5CYII=",

            seriesData: []
        };
    },
    methods: {
        init() {
            const newsEsQuery = new EsQuery();
            const querystring = require("querystring");
            newsEsQuery
                .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, newsEsQuery.and, false)
                .addStartWith('id', this.$route.params.id, newsEsQuery.and, false);
            const strategyEsJsonQuery = JSON.stringify(newsEsQuery.getArray());
            this.$http.post("api/wtcp-kb/pub/doc/search",
                querystring.stringify({
                    indexName: "wtcp-cms-news",
                    esJsonQuery: strategyEsJsonQuery,
                })).then((response) => {
                    if (response.data.status === 1) {
                        this.pointData = JSON.parse(
                            response.data.data[0]._source.content.slice(1, -1)
                        )[0].content;
                        this.picList = [];
                        this.title = this.pointData[0].name;
                        this.description = this.pointData[0].description;
                        if (this.pointData[0].img === "noImg") {
                            this.picList.push(this.noImg);
                        } else {
                            this.picList.push( `/wtcp-file/${ this.pointData[0].img.split('wtcp-file/')[1]}`);
                        }
                        this.linksData = JSON.parse(
                            response.data.data[0]._source.content.slice(1, -1)
                        )[0].relation;

                        this.pointData.forEach((item, index) => {
                            if (item.img == "noImg") {
                                item.img = this.noImg;
                            } else {
                                item.img = `/wtcp-file/${item.img.split('wtcp-file/')[1]}`;
                            }
                            Promise.all([this.getImgData(item.img, 100)]).then((images) => {
                                this.seriesData.push({
                                    name: item.name,
                                    symbol: `image://${images}`,
                                    // symbol: 'path://M250 150 L150 350 L350 350 Z',
                                    pic: item.img,
                                    text: item.description,
                                    symbolSize: 40,
                                    // draggable: true,
                                    category: 10,
                                    itemStyle: {
                                        normal: {
                                            // borderColor: color[index % 3],
                                            borderWidth: 1,
                                            shadowBlur: 20,
                                            // shadowColor: color[index % 3],
                                        },
                                    },
                                    label: {
                                        position: "bottom",
                                    },
                                });
                                if (this.seriesData.length == this.pointData.length) {
                                    this.initData();
                                    this.show = false
                                }

                            }).catch((err) => {
                                console.log("err", err)
                            })

                        });

                    }
                });
        },
        stopPropagation(e) {
            if (!this.animation) {
                e.stopPropagation();
                e.preventDefault();
            }
        },
        getImgData(imgSrc, radius) {
            return new Promise((resolve, reject) => {
                const canvas = document.createElement('canvas');
                const contex = canvas.getContext('2d');
                const img = new Image();
                const diameter = 2 * radius;
                img.onload = function () {
                    canvas.width = diameter;
                    canvas.height = diameter;
                    contex.clearRect(0, 0, diameter, diameter);
                    contex.save();
                    contex.beginPath();
                    contex.arc(radius, radius, radius, 0, 2 * Math.PI); //画出圆
                    contex.clip(); //裁剪上面的圆形
                    contex.drawImage(img, 0, 0, diameter, diameter); // 在刚刚裁剪的园上画图
                    contex.restore(); // 还原状态
                    resolve(canvas.toDataURL('image/png', 1))
                }
                img.onerror = function () {//加载失败
                    reject("加载错误");
                }
                img.src = imgSrc;
            })
        },

        initData() {
            const that = this;

            var myChart = echarts.init(document.getElementById("chart"));

            myChart.setOption({
                animationDurationUpdate: 100,
                label: {
                    normal: {
                        show: true,
                        textStyle: {
                            fontSize: 12,
                        },
                    },
                },
                series: [
                    {
                        type: "graph",
                        layout: "force",
                        symbolSize: 15,
                        focusNodeAdjacency: true,
                        roam: true,
                        label: {
                            normal: {
                                show: true,
                                textStyle: {
                                    fontSize: 12,
                                },
                                color: '#fff'
                                //   formatter: params => {
                                //       console.log(params)
                                //       let { data } = params
                                //       let str = data.message ? `: ${data.message}` : ''
                                //       return data.name + str
                                //   },
                            },
                        },
                        // force: {
                        //   repulsion: 600,
                        // },
                        force: {
                            // 力引导图基本配置
                            // initLayout: , // 力引导的初始化布局，默认使用xy轴的标点
                            repulsion: 80, // 节点之间的斥力因子。支持数组表达斥力范围，值越大斥力越大。
                            gravity: 0.02, // 节点受到的向中心的引力因子。该值越大节点越往中心点靠拢。
                            edgeLength: 50, // 边的两个节点之间的距离，这个距离也会受 repulsion影响 。值越大则长度越长
                            layoutAnimation: false, // 因为力引导布局会在多次迭代后才会稳定，这个参数决定是否显示布局的迭代动画
                            // 在浏览器端节点数据较多（>100）的时候不建议关闭，布局过程会造成浏览器假死。
                        },
                        edgeLabel: {
                            normal: {
                                show: true,
                                textStyle: {
                                    fontSize: 10,
                                },
                                formatter: "{c}",
                            },
                        },
                        data: this.seriesData,
                        links: this.linksData,
                        lineStyle: {
                            normal: {
                                // opacity: 0.6,
                                width: 1,
                                color: '#fff',
                                curveness: 0.3,
                            },
                        },
                    },
                ],
            });
            myChart.on("click", function (params) {
                that.picList = [];
                that.description = params.data.text;
                let picList = params.data.pic;
                that.picList.push(picList);
                that.title = params.data.name;
                // that.isShowContentScroll = !that.isShowContentScroll
            });

        },
        toTop() {
            document.getElementsByClassName("content-scroll")[0].scrollTo({
                top: 0,
                behavior: "smooth",
            });
        },
    },
    mounted() {
        this.minHeight = document.documentElement.clientHeight;
        document.title = this.PAGE_TITLE + '时空图谱'
        this.init();

        //弹框动画
        var mybody = document.getElementsByClassName("scrollBox")[0];
        //滑动处理
        var startX, startY;
        mybody.addEventListener(
            "touchstart",
            function (ev) {
                // ev.preventDefault();
                startX = ev.touches[0].pageX;
                startY = ev.touches[0].pageY;
            },
            false
        );
        var _this = this;
        mybody.addEventListener(
            "touchmove",
            function (ev) {
                var endX, endY;
                // ev.preventDefault();
                endX = ev.changedTouches[0].pageX;
                endY = ev.changedTouches[0].pageY;
                var X = endX - startX;
                var Y = endY - startY;
                if (Math.abs(Y) > Math.abs(X) && Y > 0) {
                    if (
                        document.getElementsByClassName("content-scroll")[0].scrollTop == 0
                    ) {
                        _this.toTop();
                        _this.animation = false;
                        _this.showFitlerList = false;
                    }
                } else if (Math.abs(Y) > Math.abs(X) && Y < 0) {
                    _this.animation = true;
                    // _this.toTop();
                } else {
                    _this.animation = false;
                }
            },
            false
        );
    },
};
